import _typeof from "@babel/runtime/helpers/typeof";
import { getCookie, getPPU } from "./cookie";
import Logger from "./log";
import Pagelife from "../lego-pagelife";
var PAGE_INFO_NAME = 'zz-pageinfo';
// 判断一下tab是否onshow
window.__APP_TAB_SHOW_SEND = 0;

// 判断否是微信小程序环境
export var isMiniprogram = function isMiniprogram() {
  if (typeof window === 'undefined') {
    return false;
  }
  return navigator.userAgent.match(/micromessenger/i) && navigator.userAgent.match(/miniprogram/i) || window.__wxjs_environment === 'miniprogram';
};

// 数组去重
export var unique = function unique(arr) {
  return arr.filter(function (item, index, arr) {
    //当前元素，在原始数组中的第一个索引==当前索引值，否则返回当前元素
    return arr.indexOf(item, 0) === index;
  });
};

// 对象数组去重，根据infoId和index两个属性去重
export var uniqueObj = function uniqueObj(arr) {
  var result = [];
  arr.forEach(function (item) {
    if (result.some(function (obj) {
      return obj.infoId === item.infoId && obj.index === item.index;
    })) {
      return;
    }
    result.push(item);
  });
  return result;
};
export var checkIntersectionObserver = function checkIntersectionObserver() {
  var inBrowser = typeof window !== 'undefined' && window !== null;
  if (inBrowser && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
    // Minimal polyfill for Edge 15's lack of `isIntersecting`
    // See: https://github.com/w3c/IntersectionObserver/issues/211
    if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
      Object.defineProperty(window.IntersectionObserverEntry.prototype, 'isIntersecting', {
        get: function get() {
          return this.intersectionRatio > 0;
        }
      });
    }
    return true;
  }
  return false;
};
export var filterQuery = function filterQuery(val) {
  // 需要去掉的 query
  var filterKeys = ['__zpm', 'tt', 'title', 'needNewWebview', 'needHideHead', 'refpagequery', 'refsubpageID'];
  var str = val[0] === '?' ? val.slice(1) : val;
  str = str.split('&').map(function (v) {
    return filterKeys.includes(v.split('=')[0]) ? false : v;
  }).filter(Boolean).join('&');
  return str;
};
var pageIdInfoArr = [];
var isMagicPath = function isMagicPath() {
  return location.pathname.includes('/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/');
};
// 获取页面链接
function getPagePath() {
  if (!window || !location) return '';

  // 魔方项目路径单独 hack 处理
  if (isMagicPath()) return location.pathname + '/';
  // 非hash
  if (!location.hash || location.hash && location.hash.slice(0, 2) !== '#/') {
    return location.pathname;
  }
  // hash
  if (location.hash.slice(0, 2) === '#/') {
    // return location.origin + location.pathname + location.hash.split('?')[0];
    var hash = location.hash.split('?')[0];
    return hash.slice(1);
  }
}

// 判断两个url是否相等
function equalUrl(url1, url2) {
  if (!url1 || !url2) return false;
  var url1Arr = url1.split('/');
  var url2Arr = url2.split('/');
  if (url2Arr.indexOf('\\') > -1) {
    var regExe = new RegExp(url2);
    return regExe.test(url1);
  }
  if (url1Arr.length !== url2Arr.length) return false;
  for (var i = 0; i < url1Arr.length; i++) {
    if (url1Arr[i] === url2Arr[i]) continue;
    if (url2Arr[i].indexOf(':') === 0) continue;
    return false;
  }
  return true;
}

// 获取页面信息
export var getPageIdInfo = function getPageIdInfo() {
  try {
    var info = getPageIdInfoOld();
    if (info) return info;
    //从dom上获取zz-pageinfo的属性
    var pageinfo = document.querySelector("[".concat(PAGE_INFO_NAME, "]"));
    if (!pageinfo) return null;
    var pageInfoStr = pageinfo.getAttribute(PAGE_INFO_NAME);
    if (!pageInfoStr) return null;
    var pageInfo = JSON.parse(pageInfoStr);
    if (!pageInfo) return null;
    return pageInfo;
  } catch (error) {
    Logger.error('获取页面信息发出错误，请检查输入的routeList格式是否正确');
  }
};

// 获取页面信息
export var getPageIdInfoOld = function getPageIdInfoOld() {
  try {
    if (!pageIdInfoArr) return null;
    var url = getPagePath();
    if (!url) return null;
    for (var i = 0; i < pageIdInfoArr.length; i++) {
      var info = pageIdInfoArr[i];
      if (!info) continue;
      // hash/history  路由
      // 业务 route 是完整路由
      if (new RegExp("".concat(info.route, "$"), 'ig').test(url)) {
        return info;
      }
      //  /: 是什么场景？
      if (info.route.indexOf('/:') > -1 && equalUrl(url, info.route)) {
        return info;
      }
    }
    return null;
  } catch (error) {
    Logger.error('获取页面信息发出错误，请检查输入的routeList格式是否正确');
  }
};

// 缓存pageId信息
export var setPageIdObj = function setPageIdObj(pageIds) {
  pageIdInfoArr = pageIds || [];
};
export var isiOS = function isiOS() {
  return !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
};
export var isAndroid = function isAndroid() {
  return navigator.userAgent.toLowerCase().indexOf('android') > -1 ? true : false;
};
export var isOpenHarmony = function isOpenHarmony() {
  var UA = navigator.userAgent.toLowerCase();
  var isOpenHarmony = /openharmony/i.test(UA);
  var isAndroid = /android/i.test(UA);
  // 检测是否为 OpenHarmony 并且不是 Android，或者是否为 ArkWeb 浏览器
  return isOpenHarmony && !isAndroid || /arkweb/i.test(UA);
};
export var compareVersion = function compareVersion(v1, v2) {
  var seq1 = v1.split('.').map(function (subVersion) {
    return parseInt(subVersion);
  });
  var seq2 = v2.split('.').map(function (subVersion) {
    return parseInt(subVersion);
  });
  var len1 = seq1.length;
  var len2 = seq2.length;
  var commonLen = Math.min(len1, len2);
  for (var i = 0; i < commonLen; ++i) {
    if (seq1[i] != seq2[i]) return seq1[i] < seq2[i] ? -1 : 1;
  }
  return len1 == len2 ? 0 : len1 < len2 ? -1 : 1;
};
export var checkSdkSupport = function checkSdkSupport() {
  var zzVersion = navigator.userAgent.match(/zzVersion\/(\S*) zzT/);
  return !!(zzVersion && Array.isArray(zzVersion) && compareVersion(zzVersion[1], '10.0.0') === 1 && (window.zhuanzhuanMApplication || window.zhuanzhuanMApplicationIos || window.hmos_bridge_service));
};
export var loadJS = function loadJS(url, cb) {
  var head = window.document.getElementsByTagName('head')[0];
  var js = window.document.createElement('script');
  js.setAttribute('type', 'text/javascript');
  js.setAttribute('async', 'async');
  js.setAttribute('src', url);
  js.onload = cb;
  head.appendChild(js);
};
export var late = function late(cb) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var timer;
  return function (params) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      cb(params);
    }, time);
  };
};
export var inviewport = function inviewport(elem, _h, _w) {
  var rect = elem.getBoundingClientRect();
  return rect.top >= 0 && rect.top <= _h || rect.bottom >= 0 && rect.bottom <= _h;
};
export var getPageUrl = function getPageUrl() {
  var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  try {
    var needScheme = opt.scheme;
    var _window$location = window.location,
      protocol = _window$location.protocol,
      hostname = _window$location.hostname,
      pathname = _window$location.pathname,
      hash = _window$location.hash;
    var url = hostname + pathname + "".concat(hash && hash.split('?')[0]);
    needScheme && (url = protocol + '//' + url);
    return url;
  } catch (e) {
    console.log(e);
  }
};
export var getUid = function getUid() {
  return getCookie('uid') || getPPU().UID || getCookie('kid') || '';
};
export var parseURL = function parseURL(url) {
  var a = document.createElement('a');
  a.href = url;
  return a;
};
export var parseUrlQuery = function parseUrlQuery(url) {
  var queryObj = {};
  try {
    var queryString = parseURL(url).search;
    queryString = queryString.slice(1);
    queryString.split('&').forEach(function (keyValue) {
      var _keyValue = keyValue.split('=');
      var key;
      var value;
      if (_keyValue.length) {
        key = _keyValue[0];
        value = _keyValue[1];
      }
      try {
        queryObj[key] = decodeURIComponent(typeof value === 'undefined' ? '' : value);
      } catch (e) {
        queryObj[key] = value;
      }
    });
  } catch (e) {}
  return queryObj;
};
export var getQueryFromTop = function getQueryFromTop(name) {
  var href = '';
  try {
    if (top !== window) {
      href = top.location.href;
    }
  } catch (error) {
    // console.error(error)
  }
  return getQuery(name, href);
};
export var getQuery = function getQuery(name) {
  var href = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (!href) href = window.location.href;
  var reg = new RegExp("(^|[&|\\?])".concat(name, "=([^&|#]*)([&|#]|$)"));
  var hrefs = href.split('?').splice(1);
  if (hrefs.length > 0) {
    var r = null;
    hrefs.forEach(function (v) {
      if (reg.test(v)) {
        r = "?".concat(v).match(reg);
      }
    });
    if (r !== null) return decodeURIComponent(r[2]);
    return r;
  }
  return null;
};

// cloneDeep 用于深拷贝
export var cloneDeep = function cloneDeep(obj) {
  // Check if the value is an object, and if it's null.
  if (_typeof(obj) !== 'object' || obj === null) {
    // If it's not an object or it's null, return the value.
    return obj;
  }
  // Create an object to hold the new values.
  var result = Array.isArray(obj) ? [] : {};
  // Loop over the keys of the object.
  for (var key in obj) {
    // Check if this key is defined on the object.
    if (obj.hasOwnProperty(key)) {
      // If so, add the cloned value to the new object.
      result[key] = cloneDeep(obj[key]);
    }
  }
  // Return the new object.
  return result;
};

// throttle 用于函数节流
export var throttle = function throttle(fn, delay) {
  var timer = null;
  return function () {
    var _this = this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (!timer) {
      timer = setTimeout(function () {
        fn.apply(_this, args);
        timer = null;
      }, delay);
    }
  };
};

// debounce 用于函数防抖
export var debounce = function debounce(fn, delay) {
  var timer = null;
  return function () {
    var _this2 = this;
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(_this2, args);
    }, delay);
  };
};
export var isZlj = function isZlj() {
  var UA = typeof window === 'undefined' ? '' : window.navigator.userAgent.toLowerCase();
  return !!~~(UA.indexOf('zhaoliangji-v2') > 0);
};
export var isZZ = function isZZ() {
  var UA = typeof window === 'undefined' ? '' : window.navigator.userAgent.toLowerCase();
  return !!~~(UA.indexOf('58zhuanzhuan') > 0);
};

// 是否存在window对象
export var isWindow = function isWindow() {
  return typeof window !== 'undefined' && window;
};

// 获取window或window上的属性和方法
export var getWindow = function getWindow(name) {
  var _window;
  if (!isWindow()) return null;
  if (name) return (_window = window) === null || _window === void 0 ? void 0 : _window[name];
  return window;
};

// 获取单个DOM对象
export var getElement = function getElement(selector, node) {
  var _ref, _ref$querySelector;
  if (!selector) return null;
  return (_ref = node || getWindow('document')) === null || _ref === void 0 || (_ref$querySelector = _ref.querySelector) === null || _ref$querySelector === void 0 ? void 0 : _ref$querySelector.call(_ref, selector);
};

// 获取多个DOM对象
export var getElements = function getElements(selector, node) {
  var _ref2, _ref2$querySelectorAl;
  if (!selector) return null;
  return ((_ref2 = node || getWindow('document')) === null || _ref2 === void 0 || (_ref2$querySelectorAl = _ref2.querySelectorAll) === null || _ref2$querySelectorAl === void 0 ? void 0 : _ref2$querySelectorAl.call(_ref2, selector)) || [];
};

// 获取body节点
export var getBody = function getBody() {
  return getElement('body');
};
export var onShowQueueOnAppTab = function onShowQueueOnAppTab(cb) {
  if (!window.appTabQueueList) {
    window.appTabQueueList = [];
  }
  window.appTabQueueList.push(cb);
  if (!window.appTabQueueListListen) {
    var appTabQueueListCb = function appTabQueueListCb() {
      // 轮询执行
      window.appTabQueueList.forEach(function (item) {
        if (item) {
          item();
        }
      });
      window.appTabQueueList = [];
    };
    // 监听onShow， 因为IOS是预加载而非预渲染，也就是一进来就会加载页面，所以必须是在onShow才执行
    window.appTabQueueListListen = setTimeout(function () {
      var appTabQueueListCbDebounce = debounce(appTabQueueListCb, 3000);
      if (isZZ()) {
        Pagelife.add('onShow', function () {
          window.__APP_TAB_SHOW_SEND = 1;
          appTabQueueListCbDebounce();
        });
      } else {
        if (document.hidden === false) {
          appTabQueueListCbDebounce();
        }
        if (/MicroMessenger/i.test(navigator.userAgent)) {
          document.addEventListener('visibilitychange', function () {
            if (document.visibilityState === 'visible') {
              appTabQueueListCbDebounce();
            }
          });
        }
      }
    }, 200);
  }
};
export var observeVisibility = function observeVisibility(callback, type) {
  var appTabShow = window.location.href.indexOf('appTabShow') > -1;
  // console.log('perf----', type, appTabShow, isZZ(), isAndroid(), window.__APP_TAB_SHOW_SEND)
  if (appTabShow && isZZ() && isAndroid() && window.__APP_TAB_SHOW_SEND === 0) {
    onShowQueueOnAppTab(function () {
      callback(true);
    });
    return;
  }
  if (document.hidden) {
    onShowQueueOnAppTab(function () {
      callback(true);
    });
  } else {
    callback(true);
  }
};